<div class="container-fluid" style="padding: 0;">
    <div class="ng-Header col-xs-12 mt-2">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Decision
    </div>

      <nz-descriptions nzTitle="Basic Information" style="padding: 10px;">
        <nz-descriptions-item nzTitle="Name of STP/SAC">
          {{ inspectionDecisionInfo?.stpName }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="STP/SAC ID">{{
          inspectionDecisionInfo?.stpRegistrationNo
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Application ID">{{
          inspectionDecisionInfo?.applicationId
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Date of Application">{{
          inspectionDecisionInfo?.applicationDate | date: "dd-MM-YYYY"
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Date of Inspection Conducted">{{
          inspectionDecisionInfo?.inspectionConductedDate | date: "dd-MM-YYYY"
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="GPS Location">NA</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Inspection Conducted By-1">{{ this.designation }}
          <!-- {{ nsdaOfficerName }} -->
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Inspection Conducted By-2">{{
          inspectionDecisionInfo?.inspectorOfficer1
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Inspection Conducted By-3">{{
          inspectionDecisionInfo?.inspectorOfficer2
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Inspection Conducted By-4">{{
          inspectionDecisionInfo?.inspectorOfficer3
          }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Date of Scrutiny Completed">{{
          inspectionDecisionInfo?.scrutinyCompleteDate
          ? (inspectionDecisionInfo?.scrutinyCompleteDate | date: "dd-MM-YYYY")
          : "NA"
          }}</nz-descriptions-item>

      </nz-descriptions>



    <div class="ng-Header col-xs-12 mt-2">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Details
      Inspection Report
    </div>
    <div nz-col [nzSpan]="24">
      <nz-table #basicTable [nzData]="detailsInspectionReportList" nzTableLayout="fixed" nzShowSizeChanger nzBordered
        nzSize="middle" nzAlign="middle" [nzFrontPagination]="false" [nzTotal]="total" [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate" [(nzPageIndex)]="page" (nzQueryParams)="onQueryParamsChange($event)">
        <ng-template #totalRowRangeTemplate let-range="range" let-total style="text-align: left">
          <div style="text-align: left">
            Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
          </div>
        </ng-template>
        <thead>
          <tr style="overflow: auto">
            <th style="width: 100px; text-align: center" rowspan="1">Sl.</th>
            <th style="text-align: center" rowspan="2">Application for</th>
            <th style="text-align: center" rowspan="2">
              Scrutiny Result for STP/SAC Registration
            </th>
            <th style="text-align: center" rowspan="2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>

            <td style="text-align: center">{{ data?.occupationName }}</td>
            <td style="text-align: center">
              {{
              data?.scrutinyResultRegistration
              ? data?.scrutinyResultRegistration
              : "NA"
              }}
            </td>
            <td style="text-align: left">
              <button (click)="showModal(data)" nz-button nzType="primary" [nzSize]="'small'">
                <i nz-icon nzType="edit" nzTheme="outline"></i>Decision
              </button>
              <i *ngIf="data?.isUpdated" style="margin-left: 5px; font-size: 20px" nz-icon [nzType]="'check-circle'"
                [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>
              |
              <button type="button" *ngIf="data.type=='STP'" (click)="onViewStpSac(inspectionId)" nz-button nzType="default" [nzSize]="'small'">
                <i nz-icon nzType="eye" nzTheme="fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>



        <div class="col-md-12 col-sm-12 col-lg-12 mt-2">
          <nz-form-item>

            <nz-form-control>
              <nz-form-label>Rollback Remarks</nz-form-label>
              <textarea

                nz-input
                placeholder="Remarks"
                [formControl]="upDatedRemarks"
                id="pandaMarts "
              ></textarea>

            </nz-form-control>
          </nz-form-item>
        </div>





    <div>

      <div class="row justify-content-end">
        <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionRollback()" [disabled]="rollbackBtnDisabled" nz-button nzType="primary"
          style="margin-top: 15px">
          Rollback
        </button>
        <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionSave()" [disabled]="enableSaveAndSubmitBtn" nz-button nzType="primary"
          style="margin-top: 15px; margin-left: 20px;">
          Save
        </button>
        <button  class="col-md-2 col-sm-12 mt-2" (click)="onAssesmentDecisionSubmit()" [disabled]="!isSubmitAll" nz-button nzType="primary"
          style="margin-top: 15px; margin-left: 20px;">
          Submit Decision
        </button>
      </div>
    </div>

</div>

          <!-- Current Application Types(currentApplicationTypeId)
           1 = Course Accreditation
           2 = Assessment Center Accreditation
           3 = Course and Assessment Center Accreditation
           4 = Registration Application -->

<nz-modal [(nzVisible)]="isVisible" nzTitle="Approval Decision and Validity" (nzOnCancel)="handleCancel()">
  <div *nzModalContent>

    <!-- Specific div for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation -->
    <div *ngIf="currentApplicationTypeId == 4">
      <form nz-form nzLayout="vertical" [formGroup]="firstForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 4">Final Decision for STP/SAC Registration
            </nz-form-label>

              <!-- First Dropdown for STP/SAC Registration -->
            <div *ngIf="currentApplicationTypeId == 4" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="firstSelect" nzShowSearch nzAllowClear formControlName="firstSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onFirstSelectFirstForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeListForRegistration"
                    [nzValue]="recommendation?.id" [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>

              <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId != 4" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="firstSelect" nzShowSearch nzAllowClear formControlName="firstSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onFirstSelectFirstForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeList" [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label [nzRequired]="firstForm.get('firstSelect')?.value == approveId" >Valid From To Till
            Date</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                  <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                  <nz-date-picker nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledFromTodayDate" formControlName="fromDate" (ngModelChange)="updateToDateFirstForm($event)" [nzDisabled]="true" ></nz-date-picker>
                  <span style="margin: 0 5px;"></span>
                  <nz-date-picker nzFormat="dd-MM-yyyy"formControlName="toDate" [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="currentApplicationTypeId == 1">
      <form nz-form nzLayout="vertical" [formGroup]="thirdForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 1">Final Decision for Course Accreditaion
            </nz-form-label>

              <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId == 1" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="firstSelect" nzShowSearch nzAllowClear formControlName="firstSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onFirstSelectThirdForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeList" [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label [nzRequired]="thirdForm.get('firstSelect')?.value == approveId" >Valid From To Till
            Date</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                  <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                  <nz-date-picker nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledFromTodayDate" formControlName="fromDate" (ngModelChange)="updateToDateThirdForm($event)" [nzDisabled]="true" ></nz-date-picker>
                  <span style="margin: 0 5px;"></span>
                  <nz-date-picker nzFormat="dd-MM-yyyy"formControlName="toDate" [nzDisabled]="thirdForm.get('firstSelect')?.value != approveId"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="currentApplicationTypeId == 2">
      <form nz-form nzLayout="vertical" [formGroup]="fourthForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired *ngIf="currentApplicationTypeId == 2">Final Decision for Assessment center
              Accreditation</nz-form-label>

              <!-- First Dropdown for 1 & 2 Course Accreditation and Assessment Center -->
            <div *ngIf="currentApplicationTypeId == 2" class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="firstSelect" nzShowSearch nzAllowClear formControlName="firstSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onFirstSelectFourthForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeList" [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <!-- First from date and to date for STP/SAC Registration, Assessment Center Accreditation, Course Accreditation  -->
        <div class="col-md-12">
          <nz-form-label [nzRequired]="fourthForm.get('firstSelect')?.value == approveId" >Valid From To Till
            Date</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="currentApplicationTypeId == 4 ? stpSacDateRanges : courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="currentApplicationTypeId == 4 ? firstFormDateChange($event, 5) : firstFormDateChange($event, 2)"></nz-range-picker> -->

                  <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="firstForm.get('firstSelect')?.value != approveId"></nz-range-picker> -->
                  <nz-date-picker nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledFromTodayDate" formControlName="fromDate" (ngModelChange)="updateToDateFourthForm($event)" [nzDisabled]="true" ></nz-date-picker>
                  <span style="margin: 0 5px;"></span>
                  <nz-date-picker nzFormat="dd-MM-yyyy"formControlName="toDate" [nzDisabled]="fourthForm.get('firstSelect')?.value != approveId"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>

    <!-- Specific div for ONLY Course and Assessment Center Accreditation -->
    <div *ngIf="currentApplicationTypeId == 3">
      <form nz-form nzLayout="vertical" [formGroup]="secondForm">
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired>Final Decision for Course Accreditaion</nz-form-label>
            <div class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="firstSelect1" nzShowSearch nzAllowClear formControlName="firstSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onFirstSelectSecondForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeList" [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-12">
          <nz-form-label [nzRequired]="secondForm.get('firstSelect')?.value == approveId" for="validDateRange">Valid From To
            Till Date</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="courseDateRanges" id="validDateRange" formControlName="validDateRange"
                  [nzDisabled]="secondForm.get('firstSelect')?.value != approveId" (nzOnCalendarChange)="courseDateChange($event)"></nz-range-picker> -->
                  <!-- <nz-range-picker id="validDateRange" formControlName="validDateRange" [(ngModel)]="selectedRange"
                  [nzDisabled]="secondForm.get('firstSelect')?.value != approveId" (ngModelChange)="onRangeChange($event)"></nz-range-picker> -->
                  <nz-date-picker nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledFromTodayDate" formControlName="fromDate" (ngModelChange)="updateToDateSecondForm($event)" [nzDisabled]="true"></nz-date-picker>
                  <span style="margin: 0 5px;"></span>
                  <nz-date-picker nzFormat="dd-MM-yyyy"formControlName="toDate" [nzDisabled]="secondForm.get('firstSelect')?.value != approveId"></nz-date-picker>
                </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="col-md-12">
          <nz-form-item>
            <nz-form-label nzRequired>Final Decision for Assessment center Accreditation</nz-form-label>
            <div class="col-md-12">
              <nz-form-control nzErrorTip="select from list">
                <nz-select id="secondSelect" nzShowSearch nzAllowClear formControlName="secondSelect"
                  nzPlaceHolder="Select from List" (ngModelChange)="onSecondSelectSecondForm($event)">
                  <nz-option *ngFor="let recommendation of recommendationTypeList" [nzValue]="recommendation?.id"
                    [nzLabel]="recommendation?.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>
        <div class="col-md-12">
          <nz-form-label [nzRequired]="secondForm.get('secondSelect')?.value == approveId" for="validDateRangeLast">Valid From
            To Till Date</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <nz-range-picker [nzRanges]="assessmentDateRanges" id="validDateRangeLast" formControlName="validDateRangeLast"
                  [nzDisabled]="secondForm.get('secondSelect')?.value != approveId" (nzOnCalendarChange)="assessmentDateChange($event)"></nz-range-picker> -->
                  <!-- <nz-range-picker id="validDateRangeLast" formControlName="validDateRangeLast"
                  [nzDisabled]="secondForm.get('secondSelect')?.value != approveId"></nz-range-picker> -->
                  <nz-date-picker nzFormat="dd-MM-yyyy" [nzDisabledDate]="disabledFromTodayDate" formControlName="fromDateLast" (ngModelChange)="updateToDateLastSecondForm($event)" [nzDisabled]="true"></nz-date-picker>
                  <span style="margin: 0 5px;"></span>
                  <nz-date-picker nzFormat="dd-MM-yyyy" formControlName="toDateLast" [nzDisabled]="secondForm.get('secondSelect')?.value != approveId"></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()">Submit</button>
  </div>
</nz-modal>
